(function(angular, Math) {
    'use strict';

    // Copied From iMedica.Prm.BusinessObject.NDD_DoseRangeChecking and converted to js

    // constants
    var singleDose = 'single dose ';
    var perDay = 'per day ';
    var AdjustedForWeight = ' (adjusted for patient\'s weight)';
    var MetricWeightMask = '0.000';
    var AdjustedForBodySurfaceArea = ' (adjusted for body surface area)';
    var maxPediatricAgeInDays = 6569;

    angular.module('aprima-legacy-common').factory('DoseRangeUtil', [
        '_',
        'NumUtil',
        'StringBuilder',
        'SystemGuid',
        DoseRangeUtil,
    ]);

    function DoseRangeUtil(
        _,
        NumUtil,
        StringBuilder,
        SystemGuid
    ) {

        var service = {
            createWeightBasedMaxMinInformation: createWeightBasedMaxMinInformation,
            formatAgeInDays: formatAgeInDays,
            getWeightBasedSummary: getWeightBasedSummary,
            mapVariableDosingFromDto: mapVariableDosingFromDto,
            mapVariableDosingToDto: mapVariableDosingToDto,
            processDoseRanges: processDoseRanges,
            GetMaxMinWarningMsg: getMaxMinWarningMsg,
            CreateMaxMinInformation: createMaxMinInformation,
            CalculateDosingInformation: calculateDosingInformation,
            allowsBsaAdjustment: allowsBsaAdjustment,
            canCalculateByMg: canCalculateByMg,
        };

        return service;

        function allowsBsaAdjustment(drc, patientAgeInDays) {
            if(!drc) {
                return false;
            }

            patientAgeInDays = patientAgeInDays || 0;

            var result = drc.BodySurfaceAreaRequired ||
                (patientAgeInDays <= maxPediatricAgeInDays &&
                drc.WeightRequired &&
                canCalculateByMg(drc));

            return result;
        }

        function canCalculateByMg(drc) {
            var strengthUomAbbr = drc && drc.IngredientStrengthUomAbbr;

            if(!strengthUomAbbr) {
                return false;
            }

            var isMg = strengthUomAbbr.toLowerCase() === 'mg';
            return isMg;
        }

        function createWeightBasedMaxMinInformation(weightBasedDoseRange) {
            if(!weightBasedDoseRange) {
                return '';
            }

            var sb = StringBuilder.init();

            addDoseRange(sb, weightBasedDoseRange.LowDoseAmount, weightBasedDoseRange.LowDoseAmountUnits, weightBasedDoseRange.HighDoseAmount, weightBasedDoseRange.HighDoseAmountUnits);
            if (sb.Length > 0)
            {
                sb.AppendLine();
            }

            addDoseRange(sb, weightBasedDoseRange.LowDoseForm, weightBasedDoseRange.LowDoseFormUnits, weightBasedDoseRange.HighDoseForm, weightBasedDoseRange.HighDoseFormUnits);
            if (sb.Length > 0)
            {
                sb.AppendLine();
            }

            addNTEInfo(sb, weightBasedDoseRange.NTEAmount, weightBasedDoseRange.NTEAmountUnits);
            addNTEInfo(sb, weightBasedDoseRange.NTEForm, weightBasedDoseRange.NTEFormUnits);
            addSingleDoseNTEInfo(sb, weightBasedDoseRange.NTESingleDoseAmount, weightBasedDoseRange.NTESingleDoseAmountUnits);

            return sb.ToString();
        }

        function formatAgeInDays(ageInDays) {
            if(ageInDays < 60) {
                return numFormat(ageInDays / 7, '0') + ' weeks';
            }
            if(ageInDays < 730) {
                return numFormat(ageInDays / 30.5, '0') + ' months';
            }
            return numFormat(ageInDays / 365, '0') + ' years';
        }

        function getWeightBasedSummary(weightBasedDosing) {
            var sb = StringBuilder.init();
            if (weightBasedDosing.minAge > 0) {
                sb.Append('Age ');
                sb.Append(formatAgeInDays(0));
                sb.Append(' - ');
                sb.AppendLine(formatAgeInDays(weightBasedDosing.minAge - 1));
                sb.AppendLine('  Manual Input Required');
            }
            weightBasedDosing.overrides.forEach(function(doseRange) {
                sb.AppendLine();
                sb.Append('Age ');
                sb.Append(formatAgeInDays(doseRange.minAge));
                sb.Append(' - ');
                sb.AppendLine(formatAgeInDays(doseRange.maxAge));
                sb.Append('  ');
                sb.Append(doseRange.overrideDosingQuantity ? doseRange.overrideDosingQuantity : weightBasedDosing.defaultDosingQuantity);
                sb.Append(' ');
                sb.Append(weightBasedDosing.unitDescription);

                var maxDose = doseRange.overrideMaximumDoseQuantity ? doseRange.overrideMaximumDoseQuantity : weightBasedDosing.defaultMaximumDoseQuantity;
                if (maxDose) {
                    sb.AppendLine();
                    sb.Append('  Maximum Dose ');
                    sb.Append(maxDose);
                    sb.Append(' ');
                    sb.Append(weightBasedDosing.maxUnitDescription);
                }
                sb.AppendLine();
            });
            sb.AppendLine();
            sb.Append('Age ');
            sb.Append(formatAgeInDays(weightBasedDosing.maxAge + 1));
            sb.AppendLine(' and older');
            sb.Append('  Manual Input Required');
            return sb.ToString();
        }

        function mapVariableDosingFromDto(variableDosingDto) {
            if(!variableDosingDto) return null;
            var variableDosing = {
                isDisabled: false,
                minAge: variableDosingDto.MinAgeInDays,
                maxAge: variableDosingDto.MaxAgeInDays,
                defaultDosingQuantity: variableDosingDto.DefaultDosingQuantity,
                defaultMaximumDoseQuantity: variableDosingDto.DefaultMaximumDoseQuantity,
                variableDosingTypeId: variableDosingDto.VariableDosingTypeId,
                overrides: _.map(variableDosingDto.Overrides, mapOverrideFromDto),
                calculationErrors: variableDosingDto.CalculationErrors,
            };
            var processedDosingType = processDosingType(variableDosing.variableDosingTypeId);
            variableDosing.unitDescription = processedDosingType.dosingUnits;
            variableDosing.maxUnitDescription = processedDosingType.maxDoseUnits;
            variableDosing.summary = getWeightBasedSummary(variableDosing);
            return variableDosing;

            function mapOverrideFromDto(override) {
                return {
                    minAge: override.MinAgeInDays,
                    maxAge: override.MaxAgeInDays,
                    overrideDosingQuantity: override.OverrideDosingQuantity,
                    overrideMaximumDoseQuantity: override.OverrideMaximumDoseQuantity,
                };
            }
        }

        function mapVariableDosingToDto(variableDosing) {
            if (!variableDosing || variableDosing.isDisabled) return null;
            return {
                DefaultDosingQuantity: variableDosing.defaultDosingQuantity,
                DefaultMaximumDoseQuantity: variableDosing.defaultMaximumDoseQuantity,
                MaxAgeInDays: variableDosing.maxAge,
                MinAgeInDays: variableDosing.minAge,
                Overrides: _.map(variableDosing.overrides, mapOverrideToDto),
                VariableDosingTypeId: variableDosing.variableDosingTypeId,
            };

            function mapOverrideToDto(override) {
                return {
                    MaxAgeInDays: override.maxAge,
                    MinAgeInDays: override.minAge,
                    OverrideDosingQuantity: override.overrideDosingQuantity,
                    OverrideMaximumDoseQuantity: override.overrideMaximumDoseQuantity,
                };
            }
        }

        function processDoseRanges(variableDoseRanges) {
            var weightBasedDoseRanges = variableDoseRanges.WeightBasedDoseRanges || [];
            var minAge = 365;
            var maxAge = 0;
            var variableDosingTypeId;

            weightBasedDoseRanges.forEach(function(doseRange) {
                var matches = doseRange.MaxMinInformation && doseRange.MaxMinInformation.match(/\r\n/g);
                var maxMinInformationRows = (matches || []).length + 1;
                doseRange.maxMinInformationRows = maxMinInformationRows;

                if (doseRange.MinAgeInDays < minAge) {
                    minAge = doseRange.MinAgeInDays;
                }
                if (doseRange.MaxAgeInDays > maxAge) {
                    maxAge = doseRange.MaxAgeInDays;
                }
                variableDosingTypeId = doseRange.VariableDosingTypeId;
            });

            var processedDosingType = processDosingType(variableDosingTypeId);

            return {
                weightBasedDoseRanges: weightBasedDoseRanges,
                dosingUnits: processedDosingType.dosingUnits,
                maxAge: maxAge,
                maxDoseUnits: processedDosingType.maxDoseUnits,
                minAge: minAge,
                variableDosingTypeId: variableDosingTypeId,
            };
        }

        function processDosingType(variableDosingTypeId) {
            var dosingUnits;
            var maxDoseUnits;

            switch(variableDosingTypeId) {
                case SystemGuid.DosingCalculatorUnitGPerKgPerDay: {
                    dosingUnits = 'g/kg/day';
                    maxDoseUnits = 'g';
                    break;
                }
                case SystemGuid.DosingCalculatorUnitMcgPerKgPerDay: {
                    dosingUnits = 'mcg/kg/day';
                    maxDoseUnits = 'mcg';
                    break;
                }
                case SystemGuid.DosingCalculatorUnitMgPerKgPerDay: {
                    dosingUnits = 'mg/kg/day';
                    maxDoseUnits = 'mg';
                    break;
                }
                case SystemGuid.DosingCalculatorUnitMlPerKgPerDay: {
                    dosingUnits = 'mL/kg/day';
                    maxDoseUnits = 'mL';
                    break;
                }
            }

            return {
                dosingUnits: dosingUnits,
                maxDoseUnits: maxDoseUnits,
            };
        }

        // this summary copied from PRM
        /// <summary>
        /// Returns >max/min warning message.
        /// </summary>
        /// <param name='amount'>amount is the dose in either mg or ml</param>
        /// <param name='frequencyPerDay'>number of times taken a day</param>
        /// <param name='durationOfTherapyInDays'>the duration in number days</param>
        /// <param name='drc'>found NDD_DoseRangeChecking</param>
        /// <returns>max/min warning message</returns>
        function getMaxMinWarningMsg(drc, amount, frequencyPerDay, durationOfTherapyInDays) {
            if (!drc) {
                return '';
            }

            if(drc.ErrorMsg && -1 === drc.ErrorMsg.indexOf('there is no dosing information supplied for this patient')) {
                return drc.ErrorMsg;
            }

            amount = amount || 0;
            frequencyPerDay = frequencyPerDay || 0;
            durationOfTherapyInDays = durationOfTherapyInDays || 0;

            var dailyDose = dailyDosing(drc, amount, frequencyPerDay);

            if (drc.AdjustedLowDose > 0 && dailyDose < drc.AdjustedLowDose) {
                return 'The dosing is less than the recommended daily dosing; ' + fdbDosingInformation(drc);
            }
            else if (drc.AdjustedHighDose > 0 && drc.AdjustedMaximumSingleDose > 0 &&
                dailyDose > drc.AdjustedHighDose && dailyDose < drc.AdjustedMaximumSingleDose) {
                return 'The dosing is greater than the recommended daily dosing; ' + fdbDosingInformation(drc);
            }
            else if (drc.AdjustedHighDose > 0 && dailyDose > drc.AdjustedHighDose) {
                return 'The dosing is greater than the recommended daily dosing; ' + fdbDosingInformation(drc);
            }
            else if ((drc.AdjustedMaximumDosePerDay > 0 && dailyDose > drc.AdjustedMaximumDosePerDay) ||
                (drc.AdjustedNteAmountPerSingleDose > 0 && dailyDose > drc.AdjustedNteAmountPerSingleDose)) {
                return 'The dosing is greater than the recommended maximum single dose; ' + fdbDosingInformation(drc);
            }
            else if (drc.LowFrequency > 0 && drc.LowFrequency > frequencyPerDay) {
                // DRCM Warning Messages #8
                return 'Prescribed frequency of administration per day is less than the recommended minimum frequency of administration range for the drug.  Please evaluate frequency.';
            }
            else if (drc.HighFrequency > 0 && frequencyPerDay > drc.HighFrequency) {
                // DRCM Warning Messages #9
                return 'Prescribed frequency of administration per day is greater than the recommended maximum frequency of administration for the drug.  Please evaluate frequency.';
            }
            else if (drc.LowDuration > 0 && durationOfTherapyInDays < drc.LowDuration) {
                // DRCM Warning Messages #10
                return 'Prescribed duration is less than the recommended low duration for the drug.';
            }
            else if (drc.HighDuration > 0 && durationOfTherapyInDays > drc.HighDuration){
                // DRCM Warning Messages #11
                return 'Prescribed duration is greater than the highest recommended duration for the drug.';
            }

            return '';
        }

        function createMaxMinInformation(drc, includeErrorMsg) {
            if(!drc) {
                return '';
            }

            var sb = StringBuilder.init();

            if (includeErrorMsg && drc.ErrorMsg && (drc.ErrorMsg.length > 0)) {
                sb.AppendLine(drc.ErrorMsg);
                sb.AppendLine();
                sb.AppendLine();
            }

            var doseLow = 0;
            var doseHigh = 0;
            var doseFormLow = 0;
            var doseFormHigh = 0;

            var doseUnit = '';
            var doseResult = getHighLowDose(drc);
            doseLow = doseResult.doseLow;
            doseHigh = doseResult.doseHigh;

            var formDoseResult = getHighLowFormDose(drc);
            doseFormLow = formDoseResult.doseFormLow;
            doseFormHigh = formDoseResult.doseFormHigh;

            if (doseLow > 0 && doseHigh > 0) {

                sb.Append(fdbDosingInformation(drc));
                sb.AppendLine();
                sb.AppendLine();

                if (drc.RangeLowDoseUnits) {
                    doseUnit = drc.RangeLowDoseUnits;
                    doseUnit = doseUnitOnly(doseUnit);
                }
                else {
                    doseUnit = '';
                }

                sb.Append('dose ');
                sb.Append(numFormat(doseLow, '[0].[00]'));
                sb.Append(' ');
                sb.Append(doseUnit);

                if (drc.RangeHighDoseUnits) {
                    doseUnit = drc.RangeHighDoseUnits;
                    doseUnit = doseUnitOnly(doseUnit);
                }
                else {
                    doseUnit = '';
                }

                sb.Append(' to ');
                sb.Append(numFormat(doseHigh, '[0].[00]'));
                sb.Append(' ');
                sb.Append(doseUnit);
                if (drc.WeightRequired) {
                    sb.Append(AdjustedForWeight);
                }
                if (drc.BodySurfaceAreaRequired) {
                    sb.Append(AdjustedForBodySurfaceArea);
                }
            }

            if (doseFormLow > 0 && doseFormHigh > 0) {
                if (drc.RangeLowDoseFormUnits) {
                    doseUnit = drc.RangeLowDoseFormUnits;
                    doseUnit = doseUnitOnly(doseUnit);
                }
                else {
                    doseUnit = '';
                }

                sb.AppendLine();
                sb.Append('dose form ');
                sb.Append(numFormat(doseFormLow, '[0].[00]'));
                sb.Append(' ');
                sb.Append(doseUnit);

                if (drc.RangeHighDoseFormUnits) {
                    doseUnit = drc.RangeHighDoseFormUnits;
                    doseUnit = doseUnitOnly(doseUnit);
                }
                else {
                    doseUnit = '';
                }

                sb.Append(' to ');
                sb.Append(numFormat(doseFormHigh, '[0].[00]'));
                sb.Append(' ');
                sb.Append(doseUnit);

                if (drc.WeightRequired) {
                    sb.Append(AdjustedForWeight);
                }
                if (drc.BodySurfaceAreaRequired) {
                    sb.Append(AdjustedForBodySurfaceArea);
                }
            }

            return sb.ToString();
        }

        function calculateDosingInformation(drc, frequencyPerDay, mg) {
            if(!drc) {
                return '';
            }

            frequencyPerDay = frequencyPerDay || 0;
            mg = mg || 0;

            if (mg > 0) {
                if (isMilliliterUnitVolume(drc)) {
                    return calculateMLFromMGDosing(drc, frequencyPerDay, mg);
                }
                else {
                    return calculateMGDosing(drc, mg);
                }
            }

            return '';
        }

        function isMilliliterUnitVolume(drc) {
            if(!drc) {
                return false;
            }

            if(drc.IngredientVolumeUomAbbr &&
               drc.IngredientVolumeUomAbbr.toLowerCase() === 'ml' &&
               drc.IngredientVolume > 0) {
                return true;
            }

            return false;
        }

        function dailyDosing(drc, amount, frequencyPerDay) {
            if(!drc) {
                return 0;
            }
            amount = amount || 0;
            frequencyPerDay = frequencyPerDay || 0;

            var dosingValue = 0;
            var dosePerDay = multiply(amount, frequencyPerDay);
            var strength = 0;
            if (drc.IngredientStrength >= 0) {
                strength = drc.IngredientStrength;
            }
            if (isMilliliterUnitVolume(drc)) {
                dosingValue = multiply(strength, divide(amount, drc.IngredientVolume));
            }
            else {
                dosingValue = multiply(strength, dosePerDay);
            }

            return dosingValue;
        }

        function addDoseRange(sb, low, lowUnits, high, highUnits) {
            if(!sb) {
                return;
            }

            if (low > 0 && high > 0) {
                sb.Append(numFormat(low, '0.00'));

                if (lowUnits) {
                    sb.Append(' ');
                    sb.Append(lowUnits);
                }
                sb.Append(' - ');
                sb.Append(numFormat(high, '0.00'));

                if (highUnits) {
                    sb.Append(' ');
                    sb.Append(highUnits);
                }
            }
        }

        function addNTEInfo(sb, nte, nteUnits) {
            if(!sb) {
                return;
            }

            if (nte > 0) {
                sb.Append('NTE: ');
                sb.Append(numFormat(nte, '0.00'));
                if (nteUnits) {
                    sb.Append(' ');
                    sb.Append(nteUnits);
                }
                sb.AppendLine();
            }
        }

        function addSingleDoseNTEInfo(sb, nte, nteUnits) {
            if(!sb) {
                return;
            }

            if (nte > 0) {
                sb.Append('Single Dose NTE: ');
                sb.Append(numFormat(nte, '0.00'));
                if (nteUnits) {
                    sb.Append(' ');
                    sb.Append(nteUnits);
                }
                sb.AppendLine();
            }
        }

        function doseFormRange(drc, sb) {
            if(!drc || !sb) {
                return;
            }

            addDoseRange(sb, drc.RangeLowDoseForm, drc.RangeLowDoseFormUnits, drc.RangeHighDoseForm, drc.RangeHighDoseFormUnits);
        }

        function doseRange(drc, sb) {
            if(!drc || !sb) {
                return;
            }

            addDoseRange(sb, drc.RangeLowDose, drc.RangeLowDoseUnits, drc.RangeHighDose, drc.RangeHighDoseUnits);
        }

        function fdbDosingInformation(drc) {
            var sb = StringBuilder.init();

            if (isMilliliterUnitVolume(drc)) {
                doseFormRange(drc, sb);
                if (sb.Length > 0) {
                    sb.Append('; ');
                }
                doseRange(drc, sb);
            }
            else {
                doseRange(drc, sb);
                if (sb.Length > 0) {
                    sb.Append('; ');
                }
                doseFormRange(drc, sb);
            }

            return sb.ToString();
        }

        /// <summary>
        /// This method gets the doselow and the dosehigh values from the dosing row and corrects
        /// the doselow and dosehigh values by the either the patient's weight or body surface area
        /// as required.
        /// </summary>
        /// <param name='drc'>NDD_DoseRangeChecking row selected for the patient's age</param>
        /// <param name='doseLow'>returns the the corrected doseLow value</param>
        /// <param name='doseHigh'>returns the the corrected doseHigh value</param>
        function getHighLowDose(drc) {
            var result = {
                doseLow: 0,
                doseHigh: 0,
            };

            if(!drc) {
                return result;
            }

            if (drc.RangeLowDose >= 0 && drc.RangeHighDose >= 0) {
                result.doseLow = drc.LowDose;
                result.doseHigh = drc.HighDose;
            }

            if (drc.WeightRequired && drc.WeightKg >= 0) {
                result.doseLow = multiply(result.doseLow, Math.max(1, drc.WeightKg));
                result.doseHigh = multiply(result.doseHigh, Math.max(1, drc.WeightKg));
            }

            if (drc.BodySurfaceAreaRequired && drc.BodySurfaceArea >= 0) {
                var bsa = drc.BodySurfaceArea;
                result.doseLow = divide(multiply(result.doseLow, bsa), 1.73);
                result.doseHigh = divide(multiply(result.doseHigh, bsa), 1.73);
            }

            return result;
        }

        /// <summary>
        /// This method gets the doseformlow and the doseformhigh values from the dosing row 
        /// and corrects the doseformlow and doseformhigh values by the either the patient's 
        /// weight or body surface area as required.
        /// </summary>
        /// <param name='drc'>NDD_DoseRangeChecking row selected for the patient's age</param>
        /// <param name='doseFormLow'>returns the the corrected doseFormLow value</param>
        /// <param name='doseFormHigh'>returns the the corrected doseFormHigh value</param>
        function getHighLowFormDose(drc) {
            var result = {
                doseFormLow: 0,
                doseFormHigh: 0,
            };

            if(!drc) {
                return result;
            }

            if (drc.RangeLowDoseForm >= 0 && drc.RangeHighDoseForm >= 0) {
                result.doseFormLow = drc.RangeLowDoseForm;
                result.doseFormHigh = drc.RangeHighDoseForm;
            }

            if (drc.WeightRequired && drc.WeightKg >= 0) {
                result.doseFormLow = multiply(result.doseFormLow, Math.max(1, drc.WeightKg));
                result.doseFormHigh = multiply(result.doseFormHigh, Math.max(1, drc.WeightKg));
            }

            if (drc.BodySurfaceAreaRequired && drc.BodySurfaceArea >= 0) {
                var bsa = drc.BodySurfaceArea;
                result.doseFormLow = divide(multiply(result.doseFormLow, bsa), 1.73);
                result.doseFormHigh = divide(multiply(result.doseFormHigh, bsa), 1.73);
            }

            return result;
        }

        function doseUnitOnly(doseUnit) {
            if(!doseUnit) {
                return doseUnit;
            }

            var len = doseUnit.indexOf('/');

            if (len > 0) {
                doseUnit = doseUnit.substr(0, len);
            }

            return doseUnit;
        }

        function dosingUnitMilliliter(drc, frequencyPerDay, dose) {
            var sb = StringBuilder.init();
            frequencyPerDay = frequencyPerDay || 0;
            dose = dose || 0;

            if (isMilliliterUnitVolume(drc)) {
                var timesPerDay = frequencyPerDay;

                if (frequencyPerDay === 0) {
                    sb.AppendLine('Cannot calculate a single dose without a frequency.');
                    timesPerDay = 1;
                }

                // do milliliter per day
                var convertDose = _.round(divide(dose, timesPerDay), 1);
                if (convertDose !== 0) {
                    sb.AppendLine();
                    sb.Append('Milliliter(s) ');

                    if (frequencyPerDay > 0) {
                        sb.Append(singleDose);
                        sb.Append(numFormat(convertDose, '[0].[0]'));
                    }
                    else {
                        sb.Append(perDay);
                        sb.Append(numFormat(multiply(convertDose, timesPerDay), '[0].[0]'));
                    }
                }
            }

            return sb.ToString();
        }

        function formatEach(dose) {
            dose = dose || 0;

            var result = '';

            var remainder = subtract(dose, Math.trunc(dose));

            if (remainder > 0.499 && remainder < 0.999) {
                result = ' 1/2';
            }

            result = numFormat(Math.trunc(dose), '[0]') + result;
            return result;
        }

        function dosingUnitMilligram(mg, strength) {
            mg = mg || 0;
            strength = strength || 0;

            var sb = StringBuilder.init();

            // do milligram per dose
            var convertDose = Math.floor(mg);
            if (convertDose !== 0) {
                sb.Append('Milligram(s) ');
                sb.Append(singleDose);
                sb.Append(numFormat(convertDose, '[0]'));
            }

            // do tables per dose
            convertDose = _.round(mg, 3);
            var formatted = formatEach(divide(convertDose, strength));
            if (formatted) {
                sb.AppendLine();
                sb.Append('Each ');
                sb.Append(singleDose);
                sb.Append(formatted);
            }

            return sb.ToString();
        }

        function calculateMLFromMGDosing(drc, frequencyPerDay, mg) {
            if(!drc) {
                return '';
            }

            frequencyPerDay = frequencyPerDay || 0;
            mg = mg || 0;

            var sb = StringBuilder.init();

            if (drc.WeightRequired && drc.WeightKg >= 0) {
                sb.Append(numFormat(multiply(mg, drc.WeightKg), '0.0'));
                sb.Append(' mg ');
                sb.AppendLine(AdjustedForWeight);
                sb.AppendLine();
            }

            if (mg > 0 &&
                drc.IngredientVolume > 0 &&
                drc.IngredientStrength > 0) {

                var ml = divide(drc.IngredientVolume, drc.IngredientStrength);
                var totalML = 0;

                if (drc.WeightRequired && drc.WeightKg >= 0) {
                    totalML = multiply(ml, mg, drc.WeightKg);
                }
                else {
                    totalML = multiply(ml, mg);
                }
                sb.Append(dosingUnitMilliliter(drc, frequencyPerDay, totalML));

                // add calculation information
                sb.AppendLine();
                sb.Append('Daily total ml: ');
                sb.Append(numFormat(totalML, '0.0'));
                if (drc.WeightRequired) {
                    sb.Append(' = ((');
                }
                else {
                    sb.Append(' = (');
                }

                sb.Append(numFormat(ml, '0.0[000]'));
                sb.Append(' (ml per mg) * ');
                sb.Append(numFormat(mg, '0.0'));

                if (drc.WeightRequired) {
                    sb.Append(') * ');
                    sb.Append(numFormat(drc.WeightKg || 0, MetricWeightMask));
                    sb.Append('(kg))');
                }
                else {
                    sb.Append(')');
                }
            }

            return sb.ToString();
        }

        function calculateMGDosing(drc, mg) {
            if(!drc) {
                return '';
            }

            mg = mg || 0;

            var sb = StringBuilder.init();

            var bsa = 0;
            var adjustedMG = mg;
            var strength = 0;
            if (drc.IngredientStrength >= 0) {
                strength = drc.IngredientStrength;
            }

            if (drc.WeightRequired) {
                adjustedMG = multiply(mg, (drc.WeightKg || 0));
                sb.Append(numFormat(adjustedMG, '0.0'));
                sb.Append(' mg ');
                sb.AppendLine(AdjustedForWeight);
                sb.AppendLine();
            }
            else if (drc.BodySurfaceAreaRequired && drc.BodySurfaceArea >= 0) {
                bsa = drc.BodySurfaceArea;
                adjustedMG = divide(multiply(bsa, mg), 1.73);
                sb.Append(numFormat(adjustedMG, '0.0'));
                sb.Append(' mg ');
                sb.AppendLine(AdjustedForBodySurfaceArea);
                sb.AppendLine();
            }

            sb.Append(dosingUnitMilligram(adjustedMG, strength));

            // added calculation information
            if (drc.WeightRequired) {
                sb.AppendLine();
                sb.AppendLine();
                sb.Append('Single dose mg: ');
                sb.Append(numFormat(adjustedMG, '0.0'));
                sb.Append(' = (');
                sb.Append(numFormat(mg, '0.0'));
                sb.Append('(mg) * ');
                sb.Append(numFormat(drc.WeightKg || 0, MetricWeightMask));
                sb.Append('(kg))');
            }
            else if (drc.BodySurfaceAreaRequired) {
                // add calculation information
                sb.AppendLine();
                sb.AppendLine();
                sb.Append('Single pediatric dose mg: ');
                sb.Append(numFormat(adjustedMG, '0.0'));
                sb.Append(' = ((');
                sb.Append(numFormat(bsa, '0.0[000]'));
                sb.Append(' (bsa m2) * ');
                sb.Append(numFormat(mg, '0.0'));
                sb.Append(' (adult dose mg)');
                sb.AppendLine(') / 1.73)');
                sb.AppendLine();
                sb.Append('Body Surface Area is calculated using the \'DuBois and DuBois 2\' formula.');
            }

            return sb.ToString();
        }

        function multiply() {
            var result = NumUtil.multiply.apply(null, arguments);
            return result;
        }

        function divide(num1, num2) {
            var result = NumUtil.divide(num1, num2);
            return result;
        }

        function subtract(num1, num2) {
            var result = NumUtil.subtract(num1, num2);
            return result;
        }

        function numFormat(num, format) {
            var result = NumUtil.format(num, format);
            return result;
        }
    }

})(window.angular, window.Math);
